export const LAYER_SELECTION_MODES = Object.freeze({
    MULTIPLE: 'multiple',
    SINGLE: 'single',
    EXCLUSIVE: 'exclusive',
});

export function buildLayerSelectionChanges(mode, selectedKey, currentlySelectedKeys) {
    const selectedKeys = Array.isArray(currentlySelectedKeys) ? currentlySelectedKeys : [];

    if (mode !== LAYER_SELECTION_MODES.SINGLE && mode !== LAYER_SELECTION_MODES.EXCLUSIVE) {
        return [{ key: selectedKey, selected: selectedKeys.indexOf(selectedKey) === -1 }];
    }

    const changes = selectedKeys
        .filter(key => key !== selectedKey)
        .map(key => ({ key, selected: false }));

    const selected = selectedKeys.indexOf(selectedKey) !== -1;
    if (!selected) {
        changes.push({ key: selectedKey, selected: true });
    } else if (mode === LAYER_SELECTION_MODES.EXCLUSIVE) {
        changes.push({ key: selectedKey, selected: false });
    }

    return changes;
}

export function lastAllowedSelectionKey(allowedKeys, selectedKeys) {
    const allowed = new Set(allowedKeys || []);
    const selected = Array.isArray(selectedKeys) ? selectedKeys : [];

    for (let index = selected.length - 1; index >= 0; index--) {
        if (allowed.has(selected[index])) return selected[index];
    }

    return null;
}
